import { HttpClient } from '@angular/common/http';
import { DestroyRef, Inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WINDOW } from '@domgen/dgx-fe-common';
import {
  CheckoutItbDirectResponse,
  CustomerDetails,
  RegisteredItem,
  REGISTRATION_CONFIG,
  RegistrationConfig,
  RegistrationSystemCode,
} from '@us-registration/util-models';
import { combineLatest, Observable, switchMap } from 'rxjs';
import { RegistrationFacade } from '../+state/registration.facade';
import { getCheckoutURLPayload } from '../utils/checkout/checkout.utils';
@Injectable({
  providedIn: 'root',
})
export class USCheckoutService {
  checkoutAccessToken = '';

  constructor(
    @Inject(REGISTRATION_CONFIG)
    protected readonly registrationConfig: RegistrationConfig,
    protected readonly httpClient: HttpClient,
    private registrationFacade: RegistrationFacade,
    private readonly destroyRef: DestroyRef,
    @Inject(WINDOW) private readonly window: Window
  ) {}

  redirectToCheckout(
    promotionalPriceEnabled: boolean,
    systemCode: RegistrationSystemCode,
    clickedPrepayCta: boolean
  ): void {
    this.getCheckoutURL(promotionalPriceEnabled, systemCode, clickedPrepayCta)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((checkoutUrl) => {
        localStorage.setItem('itbId', checkoutUrl.itbId);
        this.window.location.href = `${checkoutUrl.paymentRedirectUrl}&redirect=${location.host}/order-confirmation`;
      });
  }

  getCheckoutURL(
    promotionalPriceEnabled: boolean,
    systemCode: RegistrationSystemCode,
    clickedPrepayCta: boolean
  ): Observable<CheckoutItbDirectResponse> {
    return combineLatest([
      this.registrationFacade.registeredItem$,
      this.registrationFacade.registrationCustomerDetails$,
      this.registrationFacade.registeredItemAnnualProductDetails$,
    ]).pipe(
      switchMap(
        ([
          registeredItem,
          registrationCustomerDetails,
          registeredItemAnnualProductDetails,
        ]) => {
          const checkoutURLPayload = getCheckoutURLPayload(
            registrationCustomerDetails as CustomerDetails,
            registeredItem as RegisteredItem,
            this.registrationConfig.retailerDomain,
            promotionalPriceEnabled,
            systemCode,
            clickedPrepayCta,
            registeredItemAnnualProductDetails
          );

          return this.httpClient.post<CheckoutItbDirectResponse>(
            this.registrationConfig.checkoutApi,
            checkoutURLPayload
          );
        }
      )
    );
  }
}
